// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingError__container___2uhgp","icon":"LoadingError__icon___3yMIJ"};